import React from "react";
import EmployeeListAdminWidget from "./EmployeeListAdminWidget";

const WIDGET_FIRM_ID = "27";

const EmployeeListAdminWidgetPage = () => {
  return <EmployeeListAdminWidget firmId={WIDGET_FIRM_ID} />;
};

export default EmployeeListAdminWidgetPage;
